import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { lazy } from 'react';
import {
  BUSINESS_ROLE_GROUPS,
  EXTERNAL_OPERATOR_ROLE_GROUPS,
} from '@/components/security/AppRoles';

const Commerces = lazy(() => import('../Commerces'));
const ViewCommerce = lazy(() => import('../pages/ViewCommerce'));
const EditCommerce = lazy(() => import('../pages/EditCommerce'));
const CreateCommerce = lazy(() => import('../pages/CreateCommerce'));

const ADMIN_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...EXTERNAL_OPERATOR_ROLE_GROUPS.admin,
];

const CommercesRoutes: RouteObject[] = [
  {
    path: 'logistics-management/commerces',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <Commerces />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/commerce/:id',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <ViewCommerce />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/commerce/:id/edit',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <EditCommerce />
      </Authorize>
    ),
  },
  {
    path: 'logistics-management/commerce/create',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <CreateCommerce />
      </Authorize>
    ),
  },
];

export default CommercesRoutes;
